import { gql, useQuery } from "@apollo/client";

const GetInactiveStudentStatisticsQuery = gql`
  query getInactiveStudentStatistics {
    getInactiveStudentStatistics {
      inactivityWindowDays
      inactiveStudents {
        userId
        givenName
        familyName
        email
        speakingLevel
        userGroupName
        hasActiveGroupPlan
        hasActiveOneOnOnePlan
        lastPlanEndUtc
        lastAttendedLessonEndUtc
        nextBookedLessonStartUtc
      }
    }
  }
`;

export type InactiveStudent = {
  userId: string;
  givenName: string;
  familyName: string;
  email: string;
  speakingLevel: string;
  userGroupName: string | null;
  hasActiveGroupPlan: boolean;
  hasActiveOneOnOnePlan: boolean;
  lastPlanEndUtc: string;
  lastAttendedLessonEndUtc: string | null;
  nextBookedLessonStartUtc: string | null;
};

export type InactiveStudentStatistics = {
  inactivityWindowDays: number;
  inactiveStudents: InactiveStudent[];
};

export function useInactiveStudentStatistics() {
  const { data, loading, error } = useQuery<{
    getInactiveStudentStatistics: InactiveStudentStatistics;
  }>(GetInactiveStudentStatisticsQuery, { fetchPolicy: "cache-and-network" });

  return {
    statistics: data?.getInactiveStudentStatistics ?? null,
    loading: loading && !data,
    error,
  };
}
